module.exports = __webpack_public_path__ + "static/media/ln.beb71356.svg";